
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ModalContent from "@/components/modal/ModalContent.vue";
import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
import SkillsMultiselect from "@/components/autocompleteMultiselects/SkillsMultiselectNew.vue";
import FormWrapper from "@/components/form/FormWrapper.vue";
import FormGroup from "@/components/form/FormGroupCustom.vue";
import UIButton from "@/components/button/ui-button.vue";
import CrossIconHover from "@/components/icons/CrossIconHover.vue";
import DeleteGray from "@/components/icons/DeleteGray.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import CrossIcon from "@/components/icons/CrossIconNew.vue";

@Component({
  components: {
    ModalContent,
    ModalFullScreen,
    SkillsMultiselect,
    CrossIconHover,
    FormWrapper,
    FormGroup,
    UIButton,
    CrossIcon,
    DeleteGray,
    LoadingOverlay,
  },
})
export default class ManagementAddContractorInfo extends Vue {
  @Prop({ type: Array, required: false })
  readonly skillsIds?: Array<string>;
  @Prop({ type: String })
  readonly name?: String;

  isHovered: boolean = false;

  closeModal(): void {
    this.$emit("close");
  }

  addSkill() {
    this.$emit("add-skill", this.skillsIds);
    this.closeModal();
  }

}
